import { BrowserModule } from '@angular/platform-browser';
import { GenericErrorHandler } from './exception/generic-error-handler';
import { NgModule, ErrorHandler } from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { DataTableModule } from 'angular2-datatable';
import { FileUploadModule } from 'ng2-file-upload';

import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { SolicitarIpComponent } from './solicitar-ip/solicitar-ip.component';
import { LiberarIpComponent } from './liberar-ip/liberar-ip.component';
import { CargandoComponent } from './cargando/cargando.component';
import { ConsultarAsignacionesComponent } from './consultar-asignaciones/consultar-asignaciones.component';
import { NoAutorizadoComponent } from './no-autorizado/no-autorizado.component';
import { InicioComponent } from './inicio/inicio.component';
import { AsignacionManualComponent } from './asignacion-manual/asignacion-manual.component';
import { ConsultarVlanComponent } from './consultar-vlan/consultar-vlan.component';
import { CrearVlanComponent } from './crear-vlan/crear-vlan.component';
import { HistoricoAsignacionesComponent } from './historico-asignaciones/historico-asignaciones.component';
import { CrearSedeComponent } from './crear-sede/crear-sede.component';
import { CrearVlanSedeComponent } from './crear-vlan-sede/crear-vlan-sede.component';
import { AsignacionManualSedeComponent } from './asignacion-manual-sede/asignacion-manual-sede.component';
import { AdministrarListasComponent } from './administrar-listas/administrar-listas.component';
import { CargueMasivoComponent } from './cargue-masivo/cargue-masivo.component';
import { CargueIpsComponent } from './cargue-ips/cargue-ips.component';
import { CrearVlanNubeComponent } from './crear-vlan-nube/crear-vlan-nube.component';
import { CargueVlansNubeComponent } from './cargue-vlans-nube/cargue-vlans-nube.component';
import { CargueVlanSedeComponent } from './cargue-vlan-sede/cargue-vlan-sede.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { AsociarVlanSedeComponent } from './asociar-vlan-sede/asociar-vlan-sede.component';
import { SolicitarDirVlanComponent } from './solicitar-dir-vlan/solicitar-dir-vlan.component';
import { CrudCiudadComponent } from './crud-ciudad/crud-ciudad.component';
import { CrudCompaniasComponent } from './crud-companias/crud-companias.component';
import { CrearSupernetComponent } from './crear-supernet/crear-supernet.component';
import { AsignarSupernetComponent } from './asignar-supernet/asignar-supernet.component';
import { AsignarSupernetNubeComponent } from './asignar-supernet-nube/asignar-supernet-nube.component';
import { AdministrarSupernetComponent } from './administrar-supernet/administrar-supernet.component';
import { CrearVlanAdminComponent } from './crear-vlan-admin/crear-vlan-admin.component';
import { AccesoDenegadoComponent } from './acceso-denegado/acceso-denegado.component';
import { SeusAvailabilityGuard } from './shared/guards/seus-availability.guard';




const routes: Routes = [
  {path: '', redirectTo: '/inicio', pathMatch: 'full'},
  {path: 'solicitar-ip', component: SolicitarIpComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'liberar-ip', component: LiberarIpComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'consultar-asignacion', component: ConsultarAsignacionesComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'inicio', component: InicioComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'asignacion-manual', component: AsignacionManualComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'consultar-vlan', component: ConsultarVlanComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'crear-vlan', component: CrearVlanComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'historico-direcciones', component: HistoricoAsignacionesComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'no-autorizado', component: NoAutorizadoComponent},
  {path: 'crear-sede', component: CrearSedeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'crear-vlan-sede', component: CrearVlanSedeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'asignacion-manual-sede', component: AsignacionManualSedeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'administrar-listas', component: AdministrarListasComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'cargue-masivo', component: CargueMasivoComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'crear-vlan-nube', component: CrearVlanNubeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'cargue-ips', component: CargueIpsComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'cargue-vlans-nube', component: CargueVlansNubeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'cargue-vlan-sede', component: CargueVlanSedeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'asociar-vlan-sede', component: AsociarVlanSedeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'solicitar-dir-vlan', component: SolicitarDirVlanComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'crud-ciudad', component: CrudCiudadComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'crud-companias', component: CrudCompaniasComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'crear-supernet', component: CrearSupernetComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'asignar-supernet', component: AsignarSupernetComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'asignar-supernet-nube', component: AsignarSupernetNubeComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'administrar-supernet', component: AdministrarSupernetComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'crear-vlan-admin', component: CrearVlanAdminComponent, canActivate: [SeusAvailabilityGuard]},
  {path: 'acceso-denegado', component: AccesoDenegadoComponent}

];

@NgModule({
  declarations: [
    AppComponent,
    SolicitarIpComponent,
    LiberarIpComponent,
    CargandoComponent,
    ConsultarAsignacionesComponent,
    NoAutorizadoComponent,
    InicioComponent,
    AsignacionManualComponent,
    ConsultarVlanComponent,
    CrearVlanComponent,
    HistoricoAsignacionesComponent,
    CrearSedeComponent,
    CrearVlanSedeComponent,
    AsignacionManualSedeComponent,
    AdministrarListasComponent,
    CargueMasivoComponent,
    CargueIpsComponent,
    CrearVlanNubeComponent,
    CargueVlansNubeComponent,
    CargueVlanSedeComponent,
    AsociarVlanSedeComponent,
    SolicitarDirVlanComponent,
    CrudCiudadComponent,
    CrudCompaniasComponent,
    CrearSupernetComponent,
    AsignarSupernetComponent,
    AsignarSupernetNubeComponent,
    AdministrarSupernetComponent,
    CrearVlanAdminComponent,
    AccesoDenegadoComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    DataTableModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
    RouterModule.forRoot(routes),
    NgbModule.forRoot(),
    NgSelectModule,
    BrowserAnimationsModule,
    AutoCompleteModule,
    FileUploadModule,
    MultiSelectModule
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: ErrorHandler, useClass: GenericErrorHandler }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts